import { AREA_MEDIA_LIBRARY } from "../../constants/keys";
import { AREA } from "./constants";
export const NO_VALUE = ""; // 0 rootInbox, -1 rootTrash
export const KEYPAR_AREA = "area";
export const KEYPAR_PATH = "path";
export const decomposePath = (path) => {
    const [hrch, prnt] = path.split("_");
    if (!hrch || hrch === NO_VALUE || !prnt || prnt === NO_VALUE) {
        return [undefined, undefined];
    }
    return [String(hrch), Number(prnt)];
};
export const composePath = (hrch, prnt) => {
    if (hrch === "" || hrch === undefined || prnt === undefined)
        return "";
    return hrch + "_" + prnt;
};
export const getQueryParams = () => {
    const query = new URLSearchParams(window.location.search);
    const path = query.get(KEYPAR_PATH) || "";
    return {
        area: (query.get(KEYPAR_AREA) || ""),
        hrch: decomposePath(path)[0],
        prnt: decomposePath(path)[1],
    };
};
export const updateSearchString = ({ history, search, area, path, }) => {
    const query = new URLSearchParams(search);
    const setQuery = (key, value, fallback) => {
        const newValue = value !== undefined
            ? value !== null
                ? value
                : fallback
            : query.get(key) || fallback;
        query.set(key, newValue);
    };
    setQuery(KEYPAR_AREA, area, AREA.MYFILES);
    setQuery(KEYPAR_PATH, path, NO_VALUE);
    const newSearchString = `/${AREA_MEDIA_LIBRARY}/?${query.toString()}`;
    history.push(newSearchString);
};
export const updateSearchStringOnTenantSwitch = ({ queryLocation, queryHistory, }) => {
    var _a;
    if (location.pathname == `/${AREA_MEDIA_LIBRARY}/`) {
        const query = new URLSearchParams(queryLocation.search);
        const path = (_a = query.get(KEYPAR_PATH)) !== null && _a !== void 0 ? _a : "";
        if (path.length > 0) {
            let area = getArea();
            switch (area) {
                case AREA.TRASH_PORTAL:
                    area = AREA.TRASH_PORTALS_LIST;
                    break;
                case AREA.PORTAL:
                    area = AREA.PORTALS_LIST;
                    break;
            }
            updateSearchString({
                history: queryHistory,
                search: queryLocation.search,
                area,
                path: null,
            });
        }
    }
};
export const getArea = () => getQueryParams().area;
export const getPrnt = () => getQueryParams().prnt;
